import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '~/Common-Objects/UI/Forms/Button/Button';
import Column from '~/Common-Objects/Grids/Column/Column';
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1';
import Icons from '~/Common-Objects/UI/Icons/index';
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1';
import Paper from '~/Common-Objects/UI/Paper/Paper';
import Row from '~/Common-Objects/Grids/Row/Row';
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx';
import axios from '../../../../data/http/axios';
import i18n from '~/i18n';
import FormatNumberFuncs from '../../../../Classes/numberFormatFunctions';
import DateTimeFunctions from '../../../../Classes/dateTimeFunctions';

export default function AutomationTable({ edit = () => { } }) {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState(null)
    const history = useHistory()

    const getData = async () => {
        setLoading(true)
        const results = await axios.get('/automation?recordLimit=5&status=Running')
        if (!results.data.Automations.length) {
            setData([])
            setLoading(false)
            return
        }
        const counts = await axios.get('/automation/queueLength?ids=' + results.data.Automations.map(r => r.id).join('&ids='))
        setData(results.data.Automations.map(row => {
            var subsAffected = 0;
            if (row.steps && row.steps.length) {
                row.steps.forEach(theStep => {
                    if (!isNaN(theStep.hits)) subsAffected += theStep.hits
                })
            }

            let statusChipColor = "";
            if (row.status == "Running") statusChipColor = "square-chip-green";
            if (row.status == "Paused") statusChipColor = "square-chip-orange";
            if (row.status == "Starting") statusChipColor = "square-chip-yellow";

            const existing = counts.data.find(c => c.AutomationId == row.id)

            return {
                name: {
                    headerValue: i18n.t('automation:overview.name'),
                    value: row.name
                },
                group: {
                    headerValue: i18n.t('automation:overview.groupHeading'),
                    value: row.groupId == "-1000" ? <SquareChip>Any Group</SquareChip> : <SquareChip>{row.groupName}</SquareChip>
                },
                queueCount: {
                    headerValue: i18n.t('automation:overview.processed'),
                    value: <span>
                        {(row.status == "Running" || row.status == "Paused" || row.status === 'Starting' || row.status === 'Archived') &&
                            <SquareChip className="square-chip-large square-chip-purple square-chip-min-width">{existing ? FormatNumberFuncs.formatNumber(existing.count) : <LoadingIcons iconType="2" style={{ width: "15px", height: "15px" }} />}</SquareChip>
                        }
                        {row.status == "Draft" && <SquareChip className="square-chip-large square-chip-grey square-chip-min-width">N/A</SquareChip>}
                    </span>,
                    orderBy: true,
                    align: "center",
                    width: 200
                },
                status: {
                    headerValue: i18n.t('automation:overview.status'),
                    value: <SquareChip
                        iconLeft={<Icons icon="circle" />}
                        className={statusChipColor + " small-icon"}>
                        {i18n.t('automation:overview.' + row.status.toLowerCase())}
                    </ SquareChip >,
                    orderBy: true,
                    align: "center",
                    width: 200
                },
                createdAt: {
                    headerValue: i18n.t('automation:overview.createdDate'),
                    value: DateTimeFunctions.formatDateTime(row.createdAt, 2),
                    orderBy: true,
                    align: "center",
                    width: 200
                },
                updatedAt: {
                    headerValue: i18n.t('automation:overview.updatedDate'),
                    value: DateTimeFunctions.formatDateTime(row.updatedAt, 2),
                    orderBy: true,
                    align: "center",
                    width: 200
                }
            }
        }))
        setLoading(false)
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <Paper isLoading={loading} iconRight={<Icons icon="pencil" color="grey" />} iconRightClick={edit}>
            <div className="quickFlex mar-b24" style={{ justifyContent: "space-between" }}>
                <h4>Automations</h4>
                <Row>
                    <Column xs={12} margin={0} className="end-xs">
                        <Button className="primary" iconRight={<Icons icon="arrowRight" />} onClick={() => history.push('/cp/automation')}>View Automations</Button>
                    </Column>
                </Row>
            </div>

            {!!data && <DataTable1
                noResultsTxt={"No Running Automations"}
                tableData={data}
            />}
            {!data && <div style={{ height: 300 }}><LoadingIcons /></div>}
        </Paper>
    )
}